import Proj1 from "../assets/proj1.png";
import Proj2 from "../assets/proj2.PNG";
import Proj3 from "../assets/proj3.png";
import Proj4 from "../assets/proj4.png";
import Proj5 from "../assets/proj5.png";
import Proj6 from "../assets/proj6.PNG";
import Proj7 from "../assets/proj7.PNG";
import Proj0 from "../assets/proj0.PNG";



export const ProjectList = [
  {
    name: "Book-Swap",
    image: Proj0,
    skills: "ReactJS, Rapid Api, Material UI, context APi",
    url: "https://firebase-book-app-main-arpit871.vercel.app/register",
  },

  {
    name: "Youtube-Clone",
    image: Proj1,
    skills: "ReactJS, Rapid Api, Material UI, context APi",
    url: "https://youtube-clone-umber-psi.vercel.app/",
  },
  {
    name: "Monday Clone",
    image: Proj2,
    skills: "ReactJS, NodeJS, ExpressJS, MongoDB, AWS,",
    url: "https://monday-crm-clone-main-nnxuwxmg9-arpit871.vercel.app/"
  },
  {

    name: "Todo-List App",
    image: Proj3,
    skills: "ReactJS, localStorage, ReactBootstrap",
    url: "https://todolist-seven-beta.vercel.app/"

  },
  {
    name: "Static Website",
    image: Proj4,
    skills: "JavaScript, HTML, CSS,",
    url: "https://unwatchful-cabs.000webhostapp.com/"
  },
  {
    name: "TIC-TAC-TOE",
    image: Proj7,
    skills: "React, JavaScript, HTML, CSS, Stackblitz",
    url: "https://react-v5p7xc.stackblitz.io/"
  },
  {
    name: "Meme Generator",
    image: Proj5,
    skills: "Reactjs,context APi,bootstrap",
    url: "https://github.com/ARPIT871/Meme-Generator"
  },
  {
    name: "URL Shortner",
    image: Proj6,
    skills: "NodeJS, ExpressJS, MongoDB, EjS, HTMl/CSS",
  },
];
